import muiAppFooterBar from '@material-ui/core/BottomNavigation/BottomNavigation'
import MuiBottomNavigationAction from '@material-ui/core/BottomNavigationAction/BottomNavigationAction'
import * as React from 'react'

import styled     from 'styled-components'
import { FormattedMessage } from 'react-intl'
import UsePolitic from './UsePolitic'


const BottomNavigation = styled(muiAppFooterBar)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  background-color: ${({ theme }) => theme.headerBarColor};
  &.MuiBottomNavigationAction-root-470: ${({ theme }) => theme.headerBarColor};
`
const BottomNavigationAction = styled(MuiBottomNavigationAction)`
  color: white;
`
class AppFooterBar extends React.Component {
state = {
    dialogOpen:false
  }
  public render() {
    return (
      <div>
  <BottomNavigation
  showLabels={true}
  onChange={(event, newValue) => {
     this.setState({ dialogOpen: true });
  }}
>
          <BottomNavigationAction label={<FormattedMessage id={'button.use.politic'} />}  />
  </BottomNavigation>
  <UsePolitic
      open={this.state.dialogOpen}
      onClose={() => this.setState({ dialogOpen: false })}    />
  </div>
   )
  }
}


export default AppFooterBar





// WEBPACK FOOTER //
// ./src/components/molecules/AppFooterBar.tsx